import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";

export const NamePriceRowWrapper = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  width: "100%",
}));

export const DiscountRowWrapper = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  paddingLeft: "16px",
}));

export const DiscountRowTextWrapper = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  overflow: "hidden",
  flexGrow: 1,
}));

export const DiscountRowLabelWrapper = styled(Typography)(() => ({
  overflow: "hidden",
  textOverflow: "ellipsis",
}));

export const DiscountRowPriceWrapper = styled(Typography)(() => ({
  flexShrink: 0,
  textAlign: "right",
  minWidth: "60px",
}));

export const MofiferNameWrapper = styled(Box)(() => ({
  marginRight: "58px",
  textTransform: "uppercase",
}));

export const MofiferOptionsNameWrapper = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  gap: "16px",
  // paddingLeft: "16px",
}));

export const MofiferOptionsTextWrapper = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  overflow: "hidden",
  flexGrow: 1,
}));

export const MofiferOptionsText = styled(Typography)(() => ({
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  paddingLeft: "14px",
}));

export const MofiferOptionsPriceText = styled(Typography)(() => ({
  flexShrink: 0,
  textAlign: "right",
  minWidth: "40px",
}));
